/* Pocket Wonders — scroll experience. No libraries. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal-on-scroll for anything with .pw-reveal */
  var els = document.querySelectorAll('.pw-reveal');
  if (!('IntersectionObserver' in window) || reduce) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2. Hero orbit turns as you scroll */
  var orbit = document.querySelector('.pwh-orbit');
  /* 3. The drawer: pinned panel that swaps product as you scroll */
  var drawer = document.querySelector('[data-pw-drawer]');
  var slides = drawer ? drawer.querySelectorAll('.pwh-slide') : [];
  var dots = drawer ? drawer.querySelectorAll('.pwh-drawer__dots li') : [];
  var stage = drawer ? drawer.querySelector('.pwh-drawer__stage') : null;
  var current = -1;
  var desktop = window.matchMedia('(min-width: 990px)');

  function setSlide(i) {
    if (i === current) return;
    current = i;
    slides.forEach(function (s, n) {
      s.classList.toggle('is-active', n === i);
      s.classList.toggle('is-past', n < i);
    });
    dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    if (stage && slides[i]) stage.style.setProperty('--c', slides[i].dataset.accent);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY;
      if (orbit && !reduce) orbit.style.setProperty('--spin', (y * 0.08) + 'deg');
      if (drawer && slides.length && desktop.matches) {
        var r = drawer.getBoundingClientRect();
        var total = drawer.offsetHeight - window.innerHeight;
        var p = Math.min(Math.max(-r.top / total, 0), 0.9999);
        setSlide(Math.floor(p * slides.length));
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
  if (slides.length && desktop.matches) setSlide(0);

  /* 4. Cards lean slightly toward the pointer (desktop only) */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.pwh-vibe, .pwh-gift').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var b = card.getBoundingClientRect();
        var x = (e.clientX - b.left) / b.width - 0.5;
        var y = (e.clientY - b.top) / b.height - 0.5;
        card.style.transform = 'translateY(-6px) perspective(900px) rotateX(' + (-y * 5) + 'deg) rotateY(' + (x * 6) + 'deg)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }
})();
